<template>
  <div class="dashboard-layout">
    <div v-if="!loading">
      <div class="top">
        <h2>
          <slot name="name">{{ items.name }}</slot>
        </h2>
        <actions aria-role="list" position="is-bottom-left">
          <template>
            <slot name="actions"></slot>
          </template>
        </actions>
      </div>

      <dashboard class="dash" :id="'dashExample'" :breakpoint="'xl'">
        <dash-layout :key="'xl'" :breakpoint="'xl'">
          <dash-item
            :draggable="draggable"
            :resizable="resizable"
            v-for="item in items.elements"
            v-bind.sync="item"
            :key="item.id"
            :breakpoint="'xl'"
          >
            <div class="widget-wrapper">
              <div v-if="isEdit" class="edit-widget">
                <i class="fas fa-cogs" @click="editWidgetLayout(item.id)"></i>
              </div>
              <div v-if="isEdit" class="delete-widget">
                <i class="fas fa-trash-alt" @click="removeWidgetLayout(item.id)"></i>
              </div>
              <dashboard-widget
                :dashboardId="items.id"
                :id="item.id"
                :temp="item.temp"
                :filterValues="item.filter_values"
                @updateFilter="updateFilter"
              ></dashboard-widget>
            </div>

            <template v-slot:resizeBottomRight>
              <svg
                width="2em"
                height="2em"
                viewBox="5 5 20 20"
                focusable="false"
                role="img"
                alt="icon"
                xmlns="http://www.w3.org/2000/svg"
                fill="#08a828"
                class="b-icon bi bi-arrow-down-right mx-auto"
                data-v-11c9e491
              >
                <g data-v-11c9e491>
                  <path
                    fill-rule="evenodd"
                    d="M14 9.5a.5.5 0 01.5.5v5a.5.5 0 01-.5.5H9a.5.5 0 010-1h4.5V10a.5.5 0 01.5-.5z"
                    clip-rule="evenodd"
                  ></path>
                  <path
                    fill-rule="evenodd"
                    d="M4.646 5.646a.5.5 0 01.708 0l9 9a.5.5 0 01-.708.708l-9-9a.5.5 0 010-.708z"
                    clip-rule="evenodd"
                  ></path>
                </g>
              </svg>
            </template>
          </dash-item>
        </dash-layout>
      </dashboard>
    </div>
    <loader v-else></loader>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import Actions from '@/components/Actions'
import DashboardWidget from '@/components/DashboardWidget'

import { Dashboard, DashLayout, DashItem } from 'vue-responsive-dash'

export default {
  name: 'DashboardLayout',
  components: {
    Loader,
    Actions,
    DashboardWidget,
    Dashboard,
    DashLayout,
    DashItem
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    draggable: {
      type: Boolean,
      default: false
    },
    resizable: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    items: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    updateFilter(data) {
      this.$emit('updateFilter', data)
    },
    editWidgetLayout(key) {
      this.$emit('edit', key)
    },
    removeWidgetLayout(key) {
      this.$emit('remove', key)
    },
    resizeWidgetLayout(event, key) {
      this.$emit('resize', { event, key })
    },
    moveWidgetLayout(event, key) {
      this.$emit('move', { event, key })
    }
  },
  model: {
    event: 'change'
  }
}
</script>

<style lang="scss">
.dashboard-layout {
  .content {
    height: 100%;
    width: 100%;
    border: 2px solid #42b983;
    border-radius: 5px;
    background-color: #42b9833d;
  }
  .field.is-grouped.is-buttons-under-canvas {
    .control {
      margin-left: auto;
      margin-right: auto;
    }
  }
  .top {
    display: flow-root;
    margin-bottom: 1.25rem;
    h2 {
      font-weight: bold;
      float: left;
      font-size: 150%;
    }
    .actions {
      float: right;
    }
  }
  .widget-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    .move-widget {
      cursor: pointer;
      position: absolute;
      left: 0.2rem;
      top: 0.2rem;
      z-index: 2;
    }
    .edit-widget {
      cursor: pointer;
      position: absolute;
      right: -1.3rem;
      top: 1.5rem;
      color: #1774ff;
    }
    .delete-widget {
      cursor: pointer;
      position: absolute;
      right: -1rem;
      top: 0;
      color: #dc0000;
    }
    .resize-widget {
      cursor: pointer;
      position: absolute;
      right: 0.4rem;
      bottom: 0.2rem;
      z-index: 3;
      i {
        transform: rotate(135deg);
      }
    }
  }
}
</style>
